{
  "certificates": {
    "kpiConnector": "KPI Connector",
    "trustore": "Truststore",
    "s4Device": "S4 Devices",
    "s4ToolsApp": "S4-Tools Apps",
    "s4ManagerApp": "S4-Manager Apps",
    "s4ViewApp": "S4-View Apps",
    "sg4000": "SG4000 Apps",
    "requiredFields": "Fields with a * are required.",
    "delayInfo": "The automatic renewal period defines the period before the expiry date of the certificate from which the automatic launch of the certificate renewal procedure is triggered.",
    "delayPlaceholder": "Automatic renewal delay",
    "delayPlaceholderCustom": "Automatic renewal delay (in days)",
    "pollingPlaceholder": "Polling frequency (minutes)",
    "pollingInfoDevice": "The polling frequency corresponds to the delay between 2 exchanges between LX CONNECT and the device",
    "pollingInfoApplication": "The polling frequency corresponds to the delay between 2 exchanges between LX CONNECT and the application",
    "autoActivationLabel": "Auto-activation",
    "autoActivationAction": "Activate",
    "autoActivationInfoApplication": "The auto-activation allows to activate the application at provisionning.",
    "autoActivationInfoDevice": "The auto-activation allows to activate the device at provisionning.",
    "title": "Certificates"
  },
  "firmware": {
    "title": "Firmware",
    "firmwareManagement": "Firmware management"
  },
  "users": {
    "title": "Users",
    "activeDirectory": "Active Directory"
  },
  "application": {
    "title": "Application parameters",
    "smtpServor": "SMTP server",
    "feelAndIdentity": "Feel and Identity"
  },
  "applicationMgt": {
    "title": "Applications",
    "applicationManagement": "Applications management"
  },
  "usersPreference": {
    "title": "User's preferences",
    "userParams": "User's parameters"
  },
  "technicalVersion": {
    "label": "Technical version:",
    "unknown": "unknown"
  },
  "version": {
    "label": "Version:",
    "unknown": "unknown"
  },
  "platformMgt": {
    "title": "Platform",
    "about": "About"
  },
  "deviceConfiguration": "Device configuration"
}
